<template>
<div class="slide" 
    v-bind:style="{ width : image.view.width + slidePadding + 'px', height : image.view.height + 'px', marginRight : gutterRight + 'px', marginTop : windowMargin + 'px'  }" 
    style="position: relative"
    v-bind:id="id"
    >
    <img v-bind:src="imagePath" style="opacity: 0; " 
    class="project-image"
    v-bind:data-src="src" 
    v-bind:style="{width: image.view.width + 'px', height: image.view.height + 'px', marginTop : marginTop + 'px'  }"
    >

    <a class="download-trigger-container" @click="download" v-if="layout.type == 'large'">
            <img src="/static/images/icons/HMJ-Download.svg">
    </a>

    <!-- Image Overlay -->
    <div class="image-overlay"
        v-bind:style="{width: image.view.width + 'px', height: image.view.height + 'px', marginTop: marginTop + 'px' }"
        >
    </div>
    <div class="image-overlay-content" 
        v-bind:style="{width: image.view.width + 'px', height: image.view.height + 'px' , marginTop : marginTop + 'px' }"
        >
        <div class="overlay-content-cell">
        <h2 class="info-title" v-bind:class="{ centered : hideInfoText  }">{{this.project.title[lang]}}</h2>

        <p class="info-text" v-bind:class="{ hidden : hideInfoText  }">
        {{this.project.text[lang].description}}
        </p>
        </div>
    </div>

</div>
</template>

<script>
import store from './store/store';
export default {
    
    props : ['image', 'project', 'currentSlide', 'showInfo', 'projectIndex', 'imageIndex', 'imageScrollPosition'],

    computed : {

        lang()                  { return store.state.language },
        windowHeight()          { return store.state.layout.height; },
        windowWidth()           { return store.state.layout.width; },
        windowRatio()           { return store.getters.getLayoutRatio },
        windowMargin()           { return store.getters.getWindowMargin  },
        layout()                { return store.state.layout; },
        slidePadding()            { return 0; },
        imageRatio()            { var ratio = this.image.width/this.image.height; return ratio.toFixed(2);  },
        imageMarginTop() {  },
        src()                   { return '/static/assets2/large/' + this.project.directory + '/' + this.image.file },
        id()                    { return this.project.id + '-image-' + this.imageIndex },
        hideInfoText()           { if (this.showInfo <= 1) { return true; } else { return false ; } },
        marginTop()             { 

                return 0;
            },

        gutterRight()          { 
            if(this.layout.type == 'small' || this.layout.type == 'medium') {
                return this.layout.mobileGutter;
            } else {
                return this.layout.margin;
            }
        }
    },

    data() {
        return {
            imagePath : '/static/images/placeholder.gif'
        }
    },

    watch : {
        
        showInfo : function(val, oldVal) {

               /* console.log(this.currentSlide + ' / ' + this.imageIndex); */
                var textOpacity = 1;

                if( this.currentSlide != this.imageIndex ) {
                    textOpacity = 0;
                }


                if(oldVal == 0 && val == 2) {
                    var seq = [
                        {   e: $('#'+ this.id +' .info-text'), 
                            p : { opacity: 1   }, 
                            o: { duration: 1, easing: "easeOutQuint"  }
                        },
                            
                        {   e: $('#'+ this.id +' .image-overlay'), 
                            p : { opacity: 0.7   }, 
                            o: { duration: 1200, easing: "easeOutQuint"  }
                        },
                        {   e: $('#'+ this.id+' .image-overlay-content'), 
                            p : { opacity: textOpacity   }, 
                            o: { duration: 1500, easing: "easeOutQuint", sequenceQueue : false, delay : 200  }
                        }

                    ];
                    $.Velocity.RunSequence(seq);
                }

                if(oldVal == 0 && val == 1) {
                    
                    this.$emit('animation')
                    var seq = [
                        {   e: $('#'+ this.id +' .info-text'), 
                            p : { opacity: 0   }, 
                            o: { duration: 1, easing: "easeOutQuint"  }
                        },
                            
                        {   e: $('#'+ this.id +' .image-overlay'), 
                            p : { opacity: 0.7   }, 
                            o: { duration: 1200, easing: "easeOutQuint"  }
                        },
                        {   e: $('#'+ this.id+' .image-overlay-content'), 
                            p : { opacity: textOpacity   }, 
                            o: { duration: 1500, easing: "easeOutQuint", sequenceQueue : false   }
                        }

                    ];
                    $.Velocity.RunSequence(seq);
                }

                if(oldVal == 2 && val == 0) {
                    
                    console.log("Fade out info");
                    var seq = [
                            
                        {   e: $('#'+ this.id+' .image-overlay-content'), 
                            p : { opacity: 0   }, 
                            o: { duration: 700, easing: "easeInQuint"  }
                        },
                        {   e: $('#'+ this.id +' .image-overlay'), 
                            p : { opacity: 0   }, 
                            o: { duration: 700, easing: "easeInQuint", sequenceQueue : false  }
                        }

                    ];
                    $.Velocity.RunSequence(seq);
                }


                if(oldVal == 1 && val == 0) {
                     
                    var seq2 = [
                        {   e: $('#'+ this.id+' .image-overlay-content'), 
                            p : { opacity: 0   }, 
                            o: { duration: 1000, easing: "easeInQuint"  }
                        },
                        {   e: $('#'+ this.id +' .image-overlay'), 
                            p : { opacity: 0   }, 
                            o: { duration: 1000, 
                                easing: "easeInQuint", 
                                sequenceQueue : false, 
                                complete: function() { 
                                       this.$emit('ready');
                                    }.bind(this)}
                        }

                    ];
                    $.Velocity.RunSequence(seq2);
                }


        }
    },

    created : function() {

        },

    methods : {

        unveil : function() {
            
            console.log("Unvail " + this.image.file);
            var selector = '#' + this.id + ' > img';

            $(selector)
                .unbind()
                .on('load', function() {

                    $(this).velocity({ opacity: 1 }, { duration : 1500  });
                })
            ;

            this.imagePath = this.src;


        },

        onAnimationCompleted : function() {
            
            console.log('Animation completed');
        },

        download : function() {
            
            store.dispatch('downloadImage', this.image);
        }
        
    }



}
</script>



// WEBPACK FOOTER //
// projectImage.vue?47a7c41c